import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useState } from 'react';


import UnoButton from '../utils/UnoButton';

//Table

import { myLabelInput, unoTheme } from '../../assets/styles/unoTheme';


import _ from 'lodash';
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Collapse, DialogTitle, Divider, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@material-ui/core';
import { applyMaskAmount, getFirstDayMonth, getLastDayInMonthByMonthAndYear, getShortMonthName, parseFloatByPtCurrency, parseTaxPdfTitlePercentageToNumber } from '../utils/utils';
import MyContentLoadModal from '../utils/MyContentLoadModal';
import { useMemo } from 'react';
import moment from 'moment';

import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import { TitleAPI } from '../../API/title';
import { INSTITUITIONS_NAMES } from './SelectInstituitionModal';
import { ClientAPI } from '../../API/client';
import allActions from '../../actions';

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

// const Transition = React.forwardRef(function Transition(props, ref) {
//     return <Slide direction="up" ref={ref} {...props} />;
// });

const useStyles = makeStyles((theme) => ({
    contentModal: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
    },

    // dialogContent: {
    //     display: 'flex',
    //     background: "#eeeeee",
    //     alignItems: 'center',
    //     flexDirection: 'column',
    // },

    actionsFlex: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },

    actionsFlexRight: {
        display: 'flex',
        alignItems: 'center',
    },

    spacingRight2: {
        marginRight: theme.spacing(2),
    },
    formControl: {
        //margin: theme.spacing(1), 
        width: '100%',
        textAlign: 'left'
    },
    dialogTitle: {

        '& h2': {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
        }

    },
    noMarginTop: {
        marginTop: "0px",
    },
    tableTh: {
        fontWeight: 'bold'
    },
    toCreateRow: {
        '& .MuiTableCell-root': {
            fontSize: '12px !important',
        }
    },
    green: {
        color: unoTheme.greenMoney,
    },
    red: {
        color: unoTheme.redMoney,
    },
    blue: {
        color: "blue",
    },
    warningColor: {
        color: unoTheme.warningColor
    },
    label: myLabelInput,
    afirmativeText: {
        color: 'black'
    },
    noPaddingLeft: {
        paddingLeft: '0px',
    },
    noPaddingRight: {
        paddingRight: '0px !important',
    },

    arrowTableIcon: {
        background: unoTheme.mainColor,
        color: 'white',
        borderRadius: '4px',
        height: '22px',
        width: '22px',

        '&:hover': {
            color: 'white',
            background: unoTheme.hoverMainButtonColor
        }
    },

    ellipsis: {
        whiteSpace: "nowrap", /* Impede a quebra de linha */
        overflow: "hidden", /* Garante que o texto extra seja ocultado */
        textOverflow: "ellipsis",
    },

    ramification1: {
        display: 'flex',
        height: '100% !important',
        width: '100% !important',
        alignItems: 'center',

        '& .rLeft': {
            height: '100%',
            width: '50%',
            marginLeft: '7px',
            '& .lTop': {
                height: '50%',
                width: '100%',
                borderRight: 'solid 1px #dddee0',
            },

            '& .lBottom': {
                height: '50%',
                width: '100%',
                borderRight: 'solid 1px #dddee0',
            },
        },

        '& .rRight': {
            height: '100%',
            width: '50%',
            '& .tTop': {
                height: '50%',
                width: '100%',
                borderBottom: `solid 1px #dddee0`,
            },

            '& .tBottom': {
                height: '50%',
                width: '100%',
            },
        },

        '& .littleBall': {
            height: '7px',
            width: '8px',
            borderRadius: '50%',
            background: unoTheme.mainColor,
            marginTop: '-1.5px',
        }

    },
    tableFixed: {
        tableLayout: 'fixed',
    },
    borderOnOpen: {
        '& > *': {
            borderBottom: 'unset',
        },
    },

    rootTransactionInAsset: {
        '& .MuiTableCell-root': {
            fontSize: "12px !important",
        }
    },
    sectionTableCellHeader: {
        background: unoTheme.mainColor,
        display: 'table-cell',
        color: 'white',
        padding: '0px !important',
    },
    sectionTableCellBody: {
        background: "white",
        display: 'table-cell',
        color: 'white',
        padding: '0px !important',
    },
    multipleHorizontalTableCell: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        justifyContent: 'space-around',
        '& > div': {
            width: '50%',
        }
    },

    detailBox: {
        background: '#fafafa',
        padding: '12px 16px',
        borderTop: `solid 1px ${unoTheme.mainColor}`,
    },
    detailTitle: {
        fontSize: '12px !important',
        fontWeight: 'bold',
        marginBottom: '6px',
    },
    detailTable: {
        marginBottom: '8px',
        '& .MuiTableCell-root': {
            fontSize: '12px !important',
            padding: '4px 8px',
        },
        '& .MuiSvgIcon-root': {
            fontSize: '18px',
            verticalAlign: 'middle',
        },
    },
    detailReason: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        fontSize: '12px !important',
        color: 'black',
    },
    detailCandidates: {
        marginTop: '8px',
        fontSize: '12px !important',
        color: 'black',
        '& ul': {
            margin: '4px 0 0 0',
            paddingLeft: '18px',
        },
        '& li': {
            marginBottom: '6px',
        },
    },
    candidateAttrs: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '4px 16px',
        fontSize: '11px !important',
    },


}));

export default function DataImportTitlesFromPdfModal({ open, handleModalImport, dataToInsert }) {

    const classes = useStyles();

    const { instituition } = dataToInsert ?? { instituition: "" };

    const clientOn = useSelector(state => state.clientOn)

    const [openInvalidPdfs, setOpenInvalidPdfs] = useState(true);

    const [formattedTitlesToInsert, setFormattedTitlesToInsert] = useState([]);

    const [monthValidation, setMonthValidation] = useState();
    const [yearValidation, setYearValidation] = useState();

    const [message, setMessage] = useState("");

    const [fetchLoading, setFetchLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;

        const fetchDataAsync = async () => {

            console.log("fetchDataAsync");
            setMessage("");
            setFetchLoading(true);
            if (!dataToInsert) {
                setFormattedTitlesToInsert([]);
                setFetchLoading(false);
                return
            }
            const { titlesToInsert, clientTitles, yearValidation: selectedYearValidation } = dataToInsert;
            if (!open || !titlesToInsert?.length) {
                setFormattedTitlesToInsert([]);
                setFetchLoading(false);
                return
            }
            console.log("clientTitles: ", clientTitles);

            const splittedPeriod = titlesToInsert[0].inicio_periodo.split("/")
            let mv = parseInt(splittedPeriod[1]);
            let yv = parseInt(splittedPeriod[2]);

            if (yv != selectedYearValidation) {
                setMessage("O ano selecionado [ " + selectedYearValidation + "] deve ser igual ao encontrado no Extrato [ " + yv + " ]")
                setFetchLoading(false);
                return;
            }
            setMonthValidation(mv)
            setYearValidation(yv)

            //Relacionando dados do pdf ao
            titlesToInsert.forEach(element => {

                // console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@");
                // console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@");
                // clientTitles.forEach(el => {

                //     console.log("##############");
                //     console.log("COMPARANDO");
                //     console.log(parseFloat(parseFloat(el.pre_tax).toFixed(2)) + "==" + parseTaxPdfTitlePercentageToNumber(element.taxa) + ": " + (parseFloat(parseFloat(el.pre_tax).toFixed(2)) == parseTaxPdfTitlePercentageToNumber(element.taxa)));

                // });
                clientTitles.forEach(clientTitle => {
                    if (!element.matchDetails) {

                        element.matchDetails = {
                            "vencimento": [],
                            "dataAplicacao": [],
                            "qtdQuotas": [],
                        }

                    }

                    if (moment.utc(clientTitle.due_date).format("DD/MM/YYYY") == element.vencimento) {
                        element.matchDetails.vencimento.push(clientTitle);
                    }

                    if (moment.utc(clientTitle.purchase_date).format("DD/MM/YYYY") == element.data_aplicacao) {
                        element.matchDetails.dataAplicacao.push(clientTitle);
                    }

                    if (clientTitle.yearValidation?.lastBalance && parseFloat(clientTitle.yearValidation.lastBalance.quota_amount) == element.quantidade) {
                        element.matchDetails.qtdQuotas.push(clientTitle);
                    }
                });
                const foundClientTitle = clientTitles.filter(el =>
                    //Vencimento
                    moment.utc(el.due_date).format("DD/MM/YYYY") == element.vencimento
                    //Quantidade de cotas
                    && el.yearValidation?.lastBalance && parseFloat(el.yearValidation.lastBalance.quota_amount) == element.quantidade
                    // //Taxa
                    //&& parseFloat(parseFloat(el.pre_tax).toFixed(2)) == parseTaxPdfTitlePercentageToNumber(element.taxa)
                    // //Data de compra
                    && moment.utc(el.purchase_date).format("DD/MM/YYYY") == element.data_aplicacao
                )

                element.status = foundClientTitle.length == 1;
                element.matchs = foundClientTitle.length;
                element.theMatch = foundClientTitle;
                if (element.status) {
                    element.assetTitleId = foundClientTitle[0].id;
                }
            });

            const fullZeroTitles = titlesToInsert.filter(el => el.quantidade <= 0);
            if (fullZeroTitles.length) {
                //Verificar se já existe a movimentação de resgate para esses títulos
                const ids = fullZeroTitles.filter(el => el.assetTitleId != null).map(el => el.assetTitleId);

                if (ids.length) {

                    const startDate = getFirstDayMonth(mv, yv);
                    const endDate = getLastDayInMonthByMonthAndYear(mv, yv);
                    console.log("AAAAAAAA", startDate, endDate);
                    console.log("BBBBBBBB", ids);

                    const responseTransactionsInTitles = await TitleAPI.getTransactionsByAssetsTitlesIdsAndPeriod(ids, startDate, endDate);
                    console.log("responseTransactionsInTitles: ", responseTransactionsInTitles)
                    const transactions = responseTransactionsInTitles.body.rows;
                    fullZeroTitles.forEach(element => {
                        if (transactions.filter(el => el.title_asset_id == element.assetTitleId).length == 0) {
                            element.status = false;
                            element.missingRescueTransaction = true; //Motivo explícito: liquidado sem movimentação de resgate
                        }
                    });
                }

            }

            console.log("titlesToInsert: ", titlesToInsert);

            //Checando quem não possui saldo para o período em questão
            titlesToInsert.filter(el => el.status == true).forEach(element => {
                if (element.theMatch[0].yearValidation.months[mv] == null) {
                    element.statusFull = true
                }
            });

            setFormattedTitlesToInsert(titlesToInsert);
            setFetchLoading(false);
        };

        fetchDataAsync();

        return () => {
            isMounted = false; // previne erro se o componente for desmontado antes do async terminar
        };
    }, [open]);

    //Rótulo humano de um título do cliente (clientTitles não possui campo "paper")
    const clientTitleLabel = (ct) => {
        const base = ct.label_title_type || ct.asset_name || 'Título';
        return ct.trading_note ? `${base} • N.N ${ct.trading_note}` : base;
    };

    //Motivo pelo qual o título caiu na tabela de ações manuais
    const getManualReason = (row) => {
        if (row.missingRescueTransaction)
            return "Título liquidado (qtd. 0) sem movimentação de resgate lançada no mês.";
        if (row.matchs > 1)
            return `Múltiplos títulos (${row.matchs}) casam com todos os critérios — não é possível decidir automaticamente.`;
        return "Nenhum título do cliente casa simultaneamente os 3 critérios.";
    };

    //União (deduplicada por id) dos títulos do cliente que casam em ao menos um critério
    const getCandidateClientTitles = (row) => {
        const md = row.matchDetails || { vencimento: [], dataAplicacao: [], qtdQuotas: [] };
        const byId = {};
        const push = (ct, criterio) => {
            if (!ct) return;
            if (!byId[ct.id]) byId[ct.id] = { ct, criterios: [] };
            byId[ct.id].criterios.push(criterio);
        };
        (md.vencimento || []).forEach(ct => push(ct, 'Vencimento'));
        (md.dataAplicacao || []).forEach(ct => push(ct, 'Data aplic.'));
        (md.qtdQuotas || []).forEach(ct => push(ct, 'Qtd. cotas'));
        return Object.values(byId);
    };

    //Sub-linha com o detalhamento visual do porquê do não-match
    const renderMatchDetail = (row) => {
        const md = row.matchDetails || { vencimento: [], dataAplicacao: [], qtdQuotas: [] };
        const criterios = [
            { label: 'Vencimento', value: row.vencimento, matches: (md.vencimento || []).length },
            { label: 'Data aplic.', value: row.data_aplicacao, matches: (md.dataAplicacao || []).length },
            { label: 'Qtd. cotas', value: row.quantidade, matches: (md.qtdQuotas || []).length },
        ];
        const candidates = getCandidateClientTitles(row);
        return (
            <div className={classes.detailBox}>
                <Typography className={classes.detailTitle}>Por que este título demanda ação manual?</Typography>
                <Table size="small" className={classes.detailTable}>
                    <TableBody>
                        <TableRow>
                            <TableCell className={classes.tableTh} align="left">Critério</TableCell>
                            <TableCell className={classes.tableTh} align="center">Valor no Extrato</TableCell>
                            <TableCell className={classes.tableTh} align="center">Casa?</TableCell>
                            <TableCell className={classes.tableTh} align="center">Títulos do cliente que casam</TableCell>
                        </TableRow>
                        {criterios.map((c, i) => (
                            <TableRow key={'crit-' + i}>
                                <TableCell align="left">{c.label}</TableCell>
                                <TableCell align="center" style={{ color: "blue" }}>{c.value}</TableCell>
                                <TableCell align="center">
                                    {c.matches > 0 ? <CheckIcon className={classes.green} /> : <CloseIcon className={classes.red} />}
                                </TableCell>
                                <TableCell align="center">{c.matches}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <Typography className={classes.detailReason}>
                    <WarningIcon className={classes.warningColor} /> {getManualReason(row)}
                </Typography>
                {candidates.length ?
                    <div className={classes.detailCandidates}>
                        <span>Títulos candidatos (casam em ao menos um critério):</span>
                        <ul>
                            {candidates.map((c, i) => {
                                const matchVenc = c.criterios.includes('Vencimento');
                                const matchData = c.criterios.includes('Data aplic.');
                                const matchQtd = c.criterios.includes('Qtd. cotas');
                                const quota = c.ct.yearValidation?.lastBalance?.quota_amount;
                                return (
                                    <li key={'cand-' + i}>
                                        <div><b>{clientTitleLabel(c.ct)}</b></div>
                                        <div className={classes.candidateAttrs}>
                                            <span className={matchVenc ? classes.green : classes.red}>
                                                Venc.: {c.ct.due_date ? moment.utc(c.ct.due_date).format("DD/MM/YYYY") : "—"}
                                            </span>
                                            <span className={matchData ? classes.green : classes.red}>
                                                Data aplic.: {c.ct.purchase_date ? moment.utc(c.ct.purchase_date).format("DD/MM/YYYY") : "—"}
                                            </span>
                                            <span className={matchQtd ? classes.green : classes.red}>
                                                Qtd. cotas: {quota != null ? quota : "—"}
                                            </span>
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    </div> : null}
            </div>
        );
    };

    //Linha da tabela; quando expandable, permite abrir a sub-linha de detalhe
    const TitleRow = ({ row, index, expandable }) => {
        const [open, setOpen] = React.useState(false);
        return (
            <React.Fragment>
                <TableRow
                    className={[classes.toCreateRow, expandable && open ? "" : classes.borderOnOpen].join(' ')}
                    key={'titles-from-pdf-' + index}>
                    {expandable ?
                        <TableCell className={classes.noPaddingLeft} align="center" style={{ width: '40px' }}>
                            <IconButton size="small" className={classes.arrowTableIcon} onClick={() => setOpen(!open)}>
                                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>
                        </TableCell> : null}
                    <TableCell className={classes.noPaddingLeft} align="left">{row.paper}</TableCell>
                    <TableCell style={{ color: "blue" }} align="center">{row.vencimento}</TableCell>
                    <TableCell align="center">{row.taxa}</TableCell>
                    <TableCell align="center">{row.data_aplicacao}</TableCell>
                    <TableCell style={{ color: unoTheme.greenMoney }} align="right">{applyMaskAmount(parseFloatByPtCurrency(row.aplicacao_inicial), true)}</TableCell>
                    <TableCell style={{ background: unoTheme.auxYellowTable }} align="center">{row.status == true ? <CheckIcon className={[classes.green].join(' ')} /> : <CloseIcon className={[classes.red].join(' ')} />}</TableCell>
                    {/* <TableCell style={{ color: unoTheme.greenMoney }} className={classes.noPaddingRight} align="right">{applyMaskAmount(parseFloatByPtCurrency(row.financeiro), true)}</TableCell>  */}
                    <TableCell align="center" className={[classes.sectionTableCellBody, classes.noPaddingRight].join(" ")}>
                        <div className={classes.multipleHorizontalTableCell}>

                            <div style={{ color: "black" }}>
                                {row.quantidade}
                            </div>
                            <div style={{ color: unoTheme.greenMoney, textAlign: "right", whiteSpace: "nowrap" }}>
                                {applyMaskAmount(parseFloatByPtCurrency(row.financeiro), true)}
                            </div>

                        </div>
                    </TableCell>
                </TableRow>
                {expandable ?
                    <TableRow>
                        <TableCell style={{ padding: 0 }} colSpan={8}>
                            <Collapse in={open} timeout="auto" unmountOnExit>
                                {renderMatchDetail(row)}
                            </Collapse>
                        </TableCell>
                    </TableRow> : null}
            </React.Fragment>
        );
    };

    const renderTable = (list, expandable = false) => {
        return (
            <TableContainer component={Paper} className={classes.tableContainer} elevation={0}>
                <Table className={classes.table} stickyHeader size="small" >
                    <TableRow>
                        {expandable ? <TableCell className={classes.noPaddingLeft} style={{ width: '40px' }} /> : null}
                        <TableCell className={classes.noPaddingLeft} align="left">Título</TableCell>
                        <TableCell align="center">Vencimento</TableCell>
                        <TableCell align="center">Taxa</TableCell>
                        <TableCell align="center">Data app.</TableCell>
                        <TableCell align="right">App. inicial</TableCell>
                        <TableCell align="center" style={{ background: unoTheme.mainColor, color: "white" }}>Status</TableCell>
                        <TableCell className={[classes.sectionTableCellHeader, classes.noPaddingRight].join(" ")}
                            align="center">
                            <div>{'Informações a serem inseridas'}</div>
                            <div className={classes.multipleHorizontalTableCell}>
                                <div>{'Qtd.'}</div>
                                <div style={{ textAlign: "right" }}>{'Saldo (R$)'}</div>
                            </div>
                        </TableCell>
                        {/* <TableCell align="center">Qtd.</TableCell> */}
                        {/* <TableCell className={classes.noPaddingRight} align="right">Financeiro</TableCell> */}
                    </TableRow>
                    <TableBody>

                        {list.map((row, index) => (
                            <TitleRow
                                key={'title-row-' + index}
                                row={row}
                                index={index}
                                expandable={expandable} />
                        ))}

                    </TableBody>

                </Table>
            </TableContainer>
        )
    }

    const [creatingBvsLoading, setCreatingBvsLoading] = useState(false);
    const dispatch = useDispatch();

    const doImport = async (data, month, year) => {

        console.log("Data: ", data);
        console.log("Filtered data: ", data.filter(el => el.status == true));
        console.log("Filtered final data: ", data.filter(el => el.statusFull == true));

        const filteredToSave = data.filter(el => el.statusFull == true);

        setCreatingBvsLoading(true)
        let allSuccess = true;
        for (let i = 0; i < filteredToSave.length; i++) {
            const element = filteredToSave[i];

            const balanceToSave = {
                //Caso seja um balanço de ativo
                title_asset_id: element.assetTitleId,
                //O mês do balanço
                month_validation: month,
                //O ano do balanço
                year_validation: year,
                //Valor do balanço
                balance: parseFloatByPtCurrency(element.financeiro),

                quota_amount: element.quantidade,
            }

            console.log("BALANCE TO SAVE: ", balanceToSave);

            let response = await ClientAPI.createBalanceTitleValidation(balanceToSave)

            if (!response.success) {
                allSuccess = false
            }
        }

        setCreatingBvsLoading(false)
        dispatch(allActions.mainAlertActions.setMainAlert({
            show: true,
            type: 'success',
            message: "Saldos de títulos salvos com sucesso!"
        }))
        handleModalImport(false, true);

    }

    return (
        <Dialog
            fullWidth={true}
            maxWidth={'md'}
            open={open}
            onClose={() => handleModalImport(false)}>
            <DialogTitle
                className={classes.dialogTitle}>

                <div>
                    Títulos obtidos a partir do Extrato
                </div>
                <div>
                    {`${INSTITUITIONS_NAMES[instituition]} - ${getShortMonthName(monthValidation)}/${yearValidation}`}
                </div>

            </DialogTitle>

            {
                message == "" && creatingBvsLoading == false ?
                    <DialogContent>

                        {dataToInsert?.invalidExtracts?.length !== 0 ?
                            <>
                                <Typography className={classes.afirmativeText} style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    width: '100%',
                                    gap: "12px"
                                }}>
                                    <IconButton size="small"
                                        className={[classes.arrowTableIcon].join(' ')}
                                        onClick={() => setOpenInvalidPdfs(!openInvalidPdfs)}>
                                        {openInvalidPdfs ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                    </IconButton>
                                    <WarningIcon className={[classes.warningColor].join(' ')} /> {'Informações inválidas'}
                                </Typography>
                                <Collapse in={openInvalidPdfs} timeout="auto" unmountOnExit>
                                    {dataToInsert?.invalidExtracts.map(el => (
                                        <Typography style={{ color: unoTheme.redMoney }}>{el}</Typography>
                                    ))}

                                </Collapse>
                                <br />
                            </> : null

                        }

                        {
                            !fetchLoading ?

                                <DialogContent>
                                    {/* Titulos que demandam movimentações */}
                                    {
                                        formattedTitlesToInsert.filter(el => el.status == false).length ?
                                            <>
                                                <Typography style={{ display: "flex", alignItems: "center", gap: "8px" }}><WarningIcon style={{ color: "yellow" }} />Títulos que demandam ações manuais {`[ ${formattedTitlesToInsert.filter(el => el.status == false).length} ]`}</Typography>
                                                <Divider />
                                                {renderTable(formattedTitlesToInsert.filter(el => el.status == false), true)}
                                                <br />
                                            </> : null
                                    }

                                    {/* Titulos principais */}
                                    {
                                        formattedTitlesToInsert.filter(el => el.status == true && el.statusFull == false).length ?
                                            <>
                                                <Typography style={{ display: "flex", alignItems: "center", gap: "8px" }}><InfoIcon style={{ color: "blue" }} />Dados já preenchidos {`[ ${formattedTitlesToInsert.filter(el => el.status == true && el.statusFull == false).length} ]`}</Typography>
                                                <Divider />
                                                {renderTable(formattedTitlesToInsert.filter(el => el.status == true && el.statusFull == false))}
                                                <br />
                                            </> : null
                                    }


                                    {
                                        formattedTitlesToInsert.filter(el => el.statusFull == true).length ?
                                            <>
                                                <Typography style={{ display: "flex", alignItems: "center", gap: "8px" }}><InfoIcon style={{ color: "blue" }} />Novos dados {`[ ${formattedTitlesToInsert.filter(el => el.statusFull == true).length} ]`}</Typography>
                                                <Divider />
                                                {renderTable(formattedTitlesToInsert.filter(el => el.statusFull == true))}
                                            </> : null
                                    }



                                </DialogContent>

                                :
                                <DialogContent>
                                    <MyContentLoadModal show={true} message={'Relacionando informações aos títulos do cliente...'} />
                                </DialogContent>
                        }



                    </DialogContent>
                    :
                    <DialogContent>
                        {
                            creatingBvsLoading ?
                                <MyContentLoadModal show={true} message={'Cadastrando saldos de títulos...'} />
                                :
                                <Typography>{message}</Typography>
                        }
                    </DialogContent>
            }



            <DialogActions className={classes.actionsFlex}>

                <UnoButton onClick={() =>
                    handleModalImport(false)} color="secondary">
                    {'Cancelar'}
                </UnoButton>
                <UnoButton
                    disabled={message != "" || formattedTitlesToInsert?.filter(el => el.statusFull).length == 0}
                    className={classes.spaceRight2}
                    onClick={() => doImport(formattedTitlesToInsert, monthValidation, yearValidation)}
                    color="primary">
                    {'Iniciar importação'}
                </UnoButton>
            </DialogActions>

        </Dialog >
    );
}